export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-calendar-day"></i> Dátum szerinti újraküldés',
                event_name: "customClick",
                class: "btn btn-warning",
                event_payload: 'resendByDate'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-bug"></i>',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                seeDefinitely: true,
                event_payload: 'showStacktrace'
            },
            {
                btn_text: '<i class="fas fa-paper-plane"></i>',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                additionalButtonVisible: 'isNotResent',
                event_payload: 'resendSingle'
            }
        ],
        searchFields: [
            {
                name: "patientName",
                label: "Páciens neve",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "patientEmail",
                label: "Páciens email",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "errorType",
                label: "Hiba típusa",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "noticeType",
                label: "Értesítés típusa",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "createdOnFrom",
                label: "Létrehozva (tól)",
                formSize: 3,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "createdOnTo",
                label: "Létrehozva (ig)",
                formSize: 3,
                formVisible: true,
                formType: 'date',
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: true,
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                sort: false,
                visibility: true,
            },
            {
                name: "patientName",
                label: "Páciens neve",
                sort: false,
                visibility: true,
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                sort: false,
                visibility: true,
            },
            {
                name: "patientEmail",
                label: "Páciens email",
                sort: false,
                visibility: true,
            },
            {
                name: "errorType",
                label: "Hiba típusa",
                sort: false,
                visibility: true,
            },
            {
                name: "errorMessage",
                label: "Hiba üzenet",
                sort: false,
                visibility: true,
            },
            {
                name: "noticeType",
                label: "Értesítés típusa",
                sort: false,
                visibility: true,
            },
            {
                name: "noticeDays",
                label: "Napok száma",
                sort: false,
                visibility: true,
            },
            {
                name: "validity",
                label: "Érvényesség",
                sort: true,
                visibility: true,
            },
            {
                name: "createdOn",
                label: "Létrehozva",
                slot_name: "created_on_format",
                sort: true,
                visibility: true,
            },
            {
                name: "patientId",
                label: "Páciens ID",
                sort: false,
                visibility: false,
            },
            {
                name: "groupPatientId",
                label: "Csoport páciens ID",
                sort: false,
                visibility: false,
            },
            {
                name: "partnerId",
                label: "Partner ID",
                sort: false,
                visibility: false,
            },
            {
                name: "employabilityId",
                label: "Alkalmasság ID",
                sort: false,
                visibility: false,
            },
            {
                name: "resentOn",
                label: "Újraküldve",
                slot_name: "datetime_format",
                sort: false,
                visibility: true,
            },
            {
                name: "wholeError",
                label: "Teljes hiba (stack trace)",
                sort: false,
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                visibility: true,
                formVisible: false,
            },
        ]
    }
}
